import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { fetchUserCoupons } from '../../api/couponsApi';
import '../Profile.css';

const couponMainColor = '#ec529a'; // כמו בדף פרופיל
const couponBorderColors = ['#0cad5e', '#ef4882', '#a261a7']; // שלושת הצבעים האחרים

const Coupons = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    if (!user) navigate('/', { replace: true });
  }, [user, user?.id, navigate]);

  useEffect(() => {
    if (user?.id) {
      fetchUserCoupons(user.id).then(setCoupons).catch(() => setCoupons([]));
    }
  }, [user]);

  const items = user?.coupons || [];

  if (!user) return null;

  return (
    <div style={{ background: '#fff', minHeight: '100vh', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '30px' }}>
      
        </div>

        {coupons.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>אין קופונים להצגה</div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '20px'
          }}>
            {coupons.map((coupon, idx) => {
              const borderColor = couponBorderColors[idx % couponBorderColors.length];
              const isCopied = copiedId === coupon.id;
              const handleCopy = () => {
                navigator.clipboard.writeText(coupon.coupon_code);
                setCopiedId(coupon.id);
                setTimeout(() => setCopiedId(null), 1000);
              };
              return (
                <div
                  key={coupon.id}
                  style={{
                    background: '#fff',
                    border: `2px solid ${borderColor}`,
                    borderRadius: '12px',
                    overflow: 'visible',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'transform 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div style={{
                    background: borderColor,
                    color: '#fff',
                    padding: '15px',
                    textAlign: 'center',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px 8px 0 0',
                    gap: '10px',
                    position: 'relative',
                    overflow: 'visible'
                  }}>
                    {coupon.coupon_code}
                    <button
                      onClick={handleCopy}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative'
                      }}
                      title="העתק קוד קופון"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </svg>
                      {isCopied && (
                        <span style={{
                          position: 'absolute',
                          top: '100%',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          marginTop: '8px',
                          background: 'rgba(0,0,0,0.85)',
                          color: '#fff',
                          padding: '6px 10px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          whiteSpace: 'nowrap',
                          pointerEvents: 'none',
                          zIndex: 1000,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                        }}>
                          הועתק
                        </span>
                      )}
                    </button>
                  </div>
                  <div style={{ padding: '20px' }}>
                    <div style={{ marginBottom: '12px', color: '#555', fontSize: '14px' }}>
                      {coupon.description}
                    </div>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: 'bold',
                      color: borderColor,
                      textAlign: 'center'
                    }}>
                      {coupon.is_percentage
                        ? `${Number(coupon.discount_amount)}% הנחה`
                        : `₪${Number(coupon.discount_amount)} הנחה`}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Coupons;


